/* @flow */

import NProgress from 'nprogress'

import { observeStore } from './helpers'
import { selectInflightRequestCount } from './stores/inflightRequests'

NProgress.configure({ showSpinner: false })

/*
 * store observer.
 * starts progress bar every time
 * `inflightRequestsCount` goes from 0 to 1.
 * stops progress bar every time
 * `inflightRequestsCount` goes from 1 to 0.
 * does nothing otherwise.
 */
export default function observeStoreForNProgress(store: Object) {
  return observeStore(store, selectInflightRequestCount, (current, next) => {
    if (current === 0 && next > 0) {
      NProgress.start()
    } else if (current > 0 && next === 0) {
      NProgress.done()
    }
  })
}



// WEBPACK FOOTER //
// ./src/nprogress.js